import { render, staticRenderFns } from "./WildlifeFormPage.vue?vue&type=template&id=183c62c0&scoped=true"
import script from "./WildlifeFormPage.vue?vue&type=script&lang=js"
export * from "./WildlifeFormPage.vue?vue&type=script&lang=js"
import style0 from "./WildlifeFormPage.vue?vue&type=style&index=0&id=183c62c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c62c0",
  null
  
)

export default component.exports